(function () {
  var sectionControllers = new WeakMap();
  var mediaQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function getVideos(section) {
    return Array.prototype.slice.call(section.querySelectorAll('.section-444-media-reels__video'));
  }

  function pauseVideos(videos) {
    videos.forEach(function (video) {
      video.pause();
    });
  }

  function destroySection(section) {
    var controller = sectionControllers.get(section);

    if (!controller) {
      return;
    }

    controller.destroy();
    sectionControllers.delete(section);
  }

  function initSection(section) {
    var videos = getVideos(section);
    var autoplay = section.dataset.autoplay === 'true';
    var muted = section.dataset.muted === 'true';
    var reduceMotion = mediaQuery && mediaQuery.matches;
    var canObserve = videos.length > 0 && autoplay && muted && !reduceMotion && 'IntersectionObserver' in window;
    var observer = null;

    if (sectionControllers.has(section)) {
      return;
    }

    function destroy() {
      if (observer) {
        observer.disconnect();
      }

      pauseVideos(videos);
    }

    sectionControllers.set(section, {
      destroy: destroy
    });

    if (!canObserve) {
      pauseVideos(videos);
      return;
    }

    videos.forEach(function (video) {
      video.muted = true;
    });

    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;

          if (entry.isIntersecting) {
            video.muted = true;
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      },
      {
        threshold: 0.2
      }
    );

    videos.forEach(function (video) {
      observer.observe(video);
    });
  }

  function initSections(root) {
    var scope = root || document;
    var sections = [];

    if (scope.matches && scope.matches('[data-444-media-reels]')) {
      sections.push(scope);
    }

    if (scope.querySelectorAll) {
      sections = sections.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-444-media-reels]')));
    }

    sections.forEach(initSection);
  }

  function destroySections(root) {
    var scope = root || document;
    var sections = [];

    if (scope.matches && scope.matches('[data-444-media-reels]')) {
      sections.push(scope);
    }

    if (scope.querySelectorAll) {
      sections = sections.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-444-media-reels]')));
    }

    sections.forEach(destroySection);
  }

  function onSectionLoad(event) {
    initSections(event.target);
  }

  function onSectionUnload(event) {
    destroySections(event.target);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initSections(document);
    }, { once: true });
  } else {
    initSections(document);
  }

  document.addEventListener('shopify:section:load', onSectionLoad);
  document.addEventListener('shopify:section:unload', onSectionUnload);
})();
